import React from "react";
import Navbar from "../DashBoardComponents/Navbar";
import Footer from "../../src/DoxzonNew/Footer";
import TermsAndConContent from "./PolicyContents/TermsAndConContent";

function TermsOfUse() {
  return (
    <>
      <Navbar />
      <TermsAndConContent />
      <Footer />
    </>
  );
}

export default TermsOfUse;
